import classNames from 'classnames'
import React from 'react'
import type { StyleObject } from 'styletron-standard'
import { useStyletron } from 'styletron-react'
import { Button as WemoloButton } from '../Wemolo'
import styles from './Button.module.css'

export { WemoloButton as Button }

export enum ButtonType {
    DELETE = '#D92D20',
    SAVE = '#039855',
    INFO = 'black'
}

type WemoloButtonView = 'primary' | 'secondary' | 'destructive' | 'ghost'

const typeToView: Record<ButtonType, WemoloButtonView> = {
    [ButtonType.DELETE]: 'destructive',
    [ButtonType.SAVE]: 'primary',
    [ButtonType.INFO]: 'secondary'
}

interface CustomButtonProps {
    children: React.ReactNode
    extraProps?: StyleObject
    disabled?: boolean
    onClick?: ((a: React.SyntheticEvent<HTMLButtonElement, Event>) => unknown) | undefined
    type?: ButtonType
    isLoading?: boolean
    isActive?: boolean
    overlayColor?: string
    reverse?: boolean
    size?: 'small' | 'medium' | 'large' | 'xlarge'
}

export const CustomButton = React.forwardRef<HTMLButtonElement, CustomButtonProps>(
    (
        {
            children,
            onClick,
            disabled = false,
            type = ButtonType.INFO,
            isLoading,
            isActive = false,
            extraProps,
            size = 'small'
        },
        ref
    ) => {
        const [css] = useStyletron()
        const view: WemoloButtonView = isActive ? 'primary' : typeToView[type]
        const extraClass = extraProps ? css(extraProps) : undefined

        return (
            <WemoloButton
                ref={ref}
                view={view}
                size={size}
                disabled={disabled}
                onClick={onClick}
                loading={isLoading}
                className={classNames(styles.root, extraClass)}
            >
                {children}
            </WemoloButton>
        )
    }
)

CustomButton.displayName = 'CustomButton'
